'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteAddress = exports.setAddressSelected = exports.fetchAddresses = exports.createAddress = exports.updateAddress = undefined;

var _addressBook = require('../../actions/addressBook');

var updateAddress = exports.updateAddress = function updateAddress(dispatch) {
  return function (address) {
    return dispatch((0, _addressBook.updateAddress)(address));
  };
};

var createAddress = exports.createAddress = function createAddress(dispatch) {
  return function (address) {
    return dispatch((0, _addressBook.createAddress)(address));
  };
};

var fetchAddresses = exports.fetchAddresses = function fetchAddresses(dispatch) {
  return function () {
    return dispatch((0, _addressBook.queryAddressBook)());
  };
};

var setAddressSelected = exports.setAddressSelected = function setAddressSelected(dispatch) {
  return function (addressType, addressId) {
    return dispatch((0, _addressBook.setSelectedAddress)(addressType, addressId));
  };
};

var deleteAddress = exports.deleteAddress = function deleteAddress(dispatch) {
  return function (addressId) {
    return dispatch((0, _addressBook.deleteAddress)(addressId));
  };
};


//////////////////
// WEBPACK FOOTER
// ./shared/higherOrder/addressBook/actions.js
// module id = 2520
// module chunks = 0